import { Component } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

@Component({
  selector: 'app-dtpicker-custom-header',
  standalone: true,
  imports: [MatDatepickerModule, MatButtonModule, MatIconModule, MatTooltipModule],
  styles: [
    `
      mat-calendar-header {
        display: block;
        width: 90%;
      }

      .clear-button {
        position: absolute;
        right: 0px;
        top: 20px;
      }
    `,
  ],
  template: `
    <mat-calendar-header></mat-calendar-header>
    <button
      data-cy="app-clear-date-button"
      class="clear-button"
      color="warn"
      mat-icon-button
      matTooltip="Clear date"
      (click)="clear()"
    >
      <mat-icon>clear</mat-icon>
    </button>
  `,
})
export class CalendarCustomHeaderComponent<D> {
  constructor(private readonly datePicker: MatDatepicker<D>) {}

  clear(): void {
    this.datePicker.select(undefined);
    this.datePicker.close();
  }
}
